<template>
  <div class="as-match__item" :data-id="match.id">
    <div class="as-match__time">
      <div class="as-match__label-item">
        {{formatLocalTime(match.match_time, "h:mm DD/MM") }}
      </div>
      <!-- <div
        v-if="match.match_live_item"
        class="as-play as-d-flex as-d-lg-none"
        @click="showLinkStream(match)"
        role="button"
        type="button"
      >
        <IconPlay fill="#c72a1d"/>
      </div>
      <div class="as-match__label-item">
        <div class="as-match__label-item">{{ roundName }}</div>
      </div> -->
    </div>
    <div class="as-match__teams">
      <a :href="getLinkTeamDetail(match.home_team?.id)" class="as-match__team as-match__team--home">
        <img
          :src="getImgUrlBySport('team', match.home_team?.id)"
          :alt="match.home_team?.name"
          class="as-match__team--logo"
        />
        <div class="as-match__team--name as-match__team-home-name">
          {{ match.home_team?.name }}
        </div>
      </a>
      <ScoreVs :match="match" :size="28" />
      <a :href="getLinkTeamDetail(match.away_team?.id)" class="as-match__team as-match__team--away">
        <img
          :src="getImgUrlBySport('team', match.away_team?.id)"
          :alt="match.away_team?.name"
          class="as-match__team--logo"
        />
        <div class="as-match__team--name as-match__team-away-name">
          {{ match.away_team?.name }}
        </div>
      </a>
    </div>
    <div
      v-if="match.match_live_item"
      class="as-match__play"
      @click="showLinkStream(match)"
      role="button"
      type="button"
    >
      <IconPlay fill="#c72a1d"/>
    </div>
    <div v-else class="as-match__play"></div>
    <div class="as-match__round">
      <div v-if="roundName" class="as-match__label-item">{{ roundName }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import type { IMatch, IItemString, IRound } from "~src/interfaces";
import { formatLocalTime } from "~src/helpers/CommonHelper";
import { getRoundName } from "~src/helpers";
import { getOddValue } from "~src/helpers/OddHelper";
import IconPlay from "~src/components/icons/IconPlay.vue";
import ScoreVs from "~src/components/matches/ScoreVs.vue";

interface IProps {
  match: IMatch;
  competitionType: any;
}

const props = withDefaults(defineProps<IProps>(), {});

const emit = defineEmits(['itemClicked']);

const roundName = computed(() => {
  return getRoundName(props.match, props.competitionType);
});

const showLinkStream = (match: IMatch) => {
  emit('itemClicked', match, true);
};
</script>

<script lang="ts">
export default {};
</script>
